import { AbstractControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, switchMap, map, catchError, take } from 'rxjs/operators';
import { ConfirmEmailService } from '../components/confirm-email/confirm-email.service';


export function registeredEmailAsyncValidator(confirmEmail: ConfirmEmailService) {
    return (control: AbstractControl): Observable<any> => {
        if (!control.value) {
            return of(null);  // Return null if no value in the control
        }

        return control.valueChanges.pipe(
            debounceTime(500),  // Debounce for 500ms
            switchMap(() =>
                confirmEmail.checkExistingUser(control.value).pipe(
                    map((response) => {
                        let erroMsgText = '';

                        if (response.result?.emailExists) {
                            erroMsgText = 'Email Id is already registered on the platform';
                            return { emailExists: true, errorMessage: erroMsgText };
                        }
                         return null;  // No error if email does not exist
                    }),
                    catchError(() => {
                        // If the service fails (e.g., network error), return a generic error message
                        return of({ serverError: 'There was a problem. Please try again later.' });
                    })
                )
            ),
            take(1)  
        );
    };
}
